import React from 'react';
import PropTypes from 'prop-types';

import './CommentIcon.scss';
import { constructCn } from '../../../utilities/helperFunctions';

const CommentIcon = ({ className, isActive }) => {
    const cn = constructCn(
        'component-Icons-CommentIcon',
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );
    return (
        <svg
            className={cn}
            viewBox="0 0 30 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                id="React/comment-hover"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="comment" transform="translate(0.000000, 10.000000)">
                    <circle id="oval-fill-component" cx="15" cy="15" r="15" />
                    <g
                        id="comment-icon-fill-component"
                        transform="translate(3.000000, 6.000000)"
                    >
                        <path
                            d="M21.0454944,0 L2.95450563,0 C1.32275649,0 0,1.42943856 0,3.19279043 L0,14.1747909 C0,15.9381428 1.32275649,17.3675813 2.95450563,17.3675813 L5.08376951,17.3675813 L5.12986097,22 L9.66748087,17.3675813 L21.0454944,17.3675813 C22.6772435,17.3675813 24,15.9381428 24,14.1747909 L24,3.19279043 C24,1.42943856 22.6772435,0 21.0454944,0"
                            id="Fill-4"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

CommentIcon.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

CommentIcon.defaultProps = {
    className: '',
    isActive: false,
};

CommentIcon.displayName = 'CommentIcon';

export default React.memo(CommentIcon);
